<template>
  <div class="history-container">
    <!-- 头部 -->
    <div class="header-section">
      <div class="header-content">
        <div class="header-left">
          <div class="logo">{{ $t("foorter.subscribe") }}</div>
        </div>
        <div class="header-right">
          <van-icon
            name="chat-o"
            @click="kefu()"
            size="1.7rem"
            class="kefu-icon"
          />
          <!-- <van-icon
            name="setting-o"
            @click="$router.push('/Mine')"
            size="1.7rem"
            class="settings-icon"
          /> -->
        </div>
      </div>
      
      <!-- 标题区域 -->
      <div class="hero-section">
        <h1 class="hero-title">{{ $t("history.p1") }}</h1>
        <div class="hero-subtitle">
          <span class="highlight">{{ $t("history.Black_material") }}</span>
          <span class="subtitle-text">{{ $t("history.p2") }}</span>
        </div>
        <p class="hero-description">{{ $t("history.p3") }}</p>
      </div>
    </div>
    
    <!-- 搜索和状态 -->
    <div class="search-stats-section">
      <!-- 搜索 -->
      <div class="search-container">
        <van-search
          v-model="value"
          :placeholder="$t('history.search')"
          background="none"
          shape="round"
          :clearable="false"
          @search="search"
        >
          <template #right-icon>
            <img
              src="/img/home/search.png"
              alt=""
              @click="search"
              class="search-icon"
            />
          </template>
        </van-search>
      </div>
      
      <!-- 状态 -->
      <div class="stats-grid">
        <div class="stat-card featured-card">
          <div class="stat-icon">
            <van-icon name="star-o" size="1.5rem" />
          </div>
          <div class="stat-label">{{ $t("history.Featured") }}</div>
          <div class="stat-value">{{ totalItems || pagelist.length }}</div>
          <div class="stat-desc">{{ $t("history.Breaking") }}</div>
        </div>
        <div class="stat-card status-card">
          <div class="stat-icon">
            <van-icon name="info-o" size="1.5rem" />
          </div>
          <div class="stat-label">{{ $t("history.current_status") }}</div>
          <div class="stat-value" v-if="userInfo.vip == 0">{{ $t('Unauthenticated') }}</div>
          <div class="stat-value" v-else>{{ $t('Certified') }}</div>
          <div class="stat-desc">{{ $t("history.loading") }}</div>
        </div>
      </div>
    </div>
    
    <!-- 内容区域 -->
    <div class="main-content">
      <!-- 内容标题 -->
      <div class="section-header">
        <div class="channel-label">{{ $t("history.Channel") }}</div>
        <div class="content-title">{{ $t("history.scandals_never") }}</div>
      </div>

      <!-- 内容列表 -->
      <div class="content-grid">
        <div
          class="content-card"
          @click="playWelfareVideo(item)"
          v-for="(item, index) in renderList"
          :key="index"
        >
          <div class="card-image-container">
            <img v-lazy="item.image" alt="" class="card-image" />
            <div class="card-overlay"></div>
            <div class="card-badges">
              <span class="private-badge">{{ $t("history.Private") }}</span>
              <span class="time-badge">{{ item.create_time || "" }}</span>
            </div>
          </div>
          <div class="card-body">
            <h3 class="card-title">{{ item.cn_title || item.cn_desc }}</h3>
            <p class="card-excerpt">{{ item.cn_desc || item.cn_title }}</p>
            <div class="card-tags">
              <span class="tag">{{ item.cn_keys }}</span>
              <span class="tag">{{ $t("history.scandals_never") }}</span>
            </div>
            <div class="card-footer">
              <button class="play-btn" @click.stop="playWelfareVideo(item)">{{ $t("history.play") }}</button>
              <span class="receive-text">{{ $t("history.receive") }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 无数据提示 -->
      <div
        v-if="renderList.length === 0"
        class="empty-state"
      >
        {{ value || $t("history.none") }}
      </div>

      <!-- 分页 -->
      <div class="pagination-section" v-if="!value && totalItems > pageSize">
        <van-pagination
          v-model="currentPage"
          mode="simple"
          :total-items="totalItems"
          :items-per-page="pageSize"
          @change="getpagelist"
          :prev-text="$t('history.prev')"
          :next-text="$t('history.next')"
        >
        </van-pagination>
      </div>
    </div>
    <van-popup
      v-model="showVideoPopup"
      class="welfare-video-popup"
      :close-on-click-overlay="true"
      @closed="closeWelfareVideo"
    >
      <div class="welfare-video-panel">
        <van-icon name="cross" class="welfare-video-close" @click="showVideoPopup = false" />
        <div class="welfare-video-title">{{ currentVideoTitle }}</div>
        <video
          v-if="currentVideoUrl"
          ref="welfareVideo"
          class="welfare-video-player"
          :src="currentVideoUrl"
          @loadedmetadata="skipWelfareAd"
          @canplay="skipWelfareAd"
          @play="skipWelfareAd"
          controls
          autoplay
          playsinline
          webkit-playsinline
        ></video>
      </div>
    </van-popup>

  </div>
</template>

<script>
export default {
  name: 'History',
  created() {
    localStorage.removeItem("history_page_cache");
    this.getpagelist();
    this.getUserInfo()
  },
  data() {
    return {
      value: "",
      userInfo:'',
      currentPage: 1,
      pageSize: 10,
      historyRandomSeed: `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`,
      pagelist: [],
      catelist: [],
      totalItems: 0,
      showVideoPopup: false,
      currentVideoUrl: "",
      currentVideoTitle: "",
      welfareVideoSkipSeconds: 10,
      welfareVideoSkipApplied: false,
      baseUrl: "https://admin.methsding.com/",
    };
  },
  computed: {
    renderList() {
      if (this.value.trim() !== "" && this.catelist.length > 0) {
        return this.catelist;
      }
      return this.pagelist;
    },
  },
  methods: {
    applyCachedHistoryData() {
      const cache = localStorage.getItem("history_page_cache");
      if (!cache) return false;
      try {
        const parsed = JSON.parse(cache);
        this.pagelist = Array.isArray(parsed.pagelist) ? parsed.pagelist : [];
        this.totalItems = parsed.totalItems || this.totalItems;
        return true;
      } catch (error) {
        return false;
      }
    },
    persistHistoryData() {
      localStorage.setItem(
        "history_page_cache",
        JSON.stringify({
          pagelist: this.pagelist,
          totalItems: this.totalItems,
        })
      );
    },
    kefu(){
     this.$toast(this.$t("Universal.personal")); 
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
        data: {
          type: 1,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;

          this.menu_top = 15;
          /* if (this.userInfo.status !== 1) {
						this.$toast(this.$t("video.account_out"));
						localStorage.clear()
						this.$router.push({
							path: '/Login'
						})
					} */
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    // 万能图片方法
    getImageUrl(img) {
      if (!img) return "../../assets/bc-img/n1.jpg";
      if (img.startsWith("http")) return img;
      return this.baseUrl + img;
    },

    // 搜索
    search() {
      this.catelist = [];
      if (this.value.trim() === "") {
        this.currentPage = 1;
        this.getpagelist();
        return;
      }
      this.getcatelist();
    },

    playWelfareVideo(item) {
      const videoUrl = item && item.video_url ? item.video_url : "";
      if (!videoUrl) {
        this.$toast(this.$t("history.kf"));
        return;
      }
      this.welfareVideoSkipApplied = false;
      this.currentVideoUrl = videoUrl;
      this.currentVideoTitle = item.cn_title || item.title || "";
      this.showVideoPopup = true;
      this.$nextTick(() => {
        const video = this.$refs.welfareVideo;
        if (video && video.play) {
          this.skipWelfareAd();
          video.play().catch(() => {});
        }
      });
    },
    skipWelfareAd() {
      const video = this.$refs.welfareVideo;
      if (!video || this.welfareVideoSkipApplied) return;

      const skipTo = this.welfareVideoSkipSeconds;
      const seek = () => {
        try {
          if (Number.isFinite(video.duration) && video.duration > 0 && video.duration <= skipTo) {
            this.welfareVideoSkipApplied = true;
            return;
          }

          video.currentTime = skipTo;
          this.welfareVideoSkipApplied = true;
        } catch (error) {
          setTimeout(() => {
            try {
              if (!this.welfareVideoSkipApplied && this.$refs.welfareVideo) {
                this.$refs.welfareVideo.currentTime = skipTo;
                this.welfareVideoSkipApplied = true;
              }
            } catch (retryError) {}
          }, 300);
        }
      };

      if (video.readyState >= 1) {
        seek();
      }
    },
    closeWelfareVideo() {
      const video = this.$refs.welfareVideo;
      if (video && video.pause) {
        video.pause();
      }
      this.currentVideoUrl = "";
      this.currentVideoTitle = "";
      this.welfareVideoSkipApplied = false;
    },

    toast() {
      this.$toast(this.$t("history.kf"));
    },

    // ==============================
    // 真实分页 + 动态获取总条数
    // ==============================
    getpagelist(page = this.currentPage) {
      this.currentPage = page;
      this.$http({
        method: "get",
        url: "pagelist",
        data: {
          page: this.currentPage,
          limit: this.pageSize,
          cate_id: 3,
          random: 1,
          seed: this.historyRandomSeed,
        },
      }).then((res) => {
        if (res.code === 200) {
          try {
            const payload = res.data || {};
            let result =
              typeof payload.data === "string"
                ? JSON.parse(payload.data)
                : payload.data;

            // 列表数据
            this.pagelist = Array.isArray(result) ? result : [];
            this.totalItems = Number(payload.count) || this.pagelist.length;
            this.$nextTick(() => {
              const mainContent = this.$el.querySelector(".main-content");
              if (mainContent && mainContent.scrollIntoView) {
                mainContent.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            });
          } catch (e) {
            this.pagelist = [];
            this.totalItems = 0;
          }
        }
      });
    },

    // 🔥🔥🔥 搜索接口（后端要求：不传任何参数）
    getcatelist() {
      this.$http({
        method: "get",
        url: "catelist", // 完整接口地址
        data: {
          cn_keys: this.value,
          // keyword:this.value
        },
      }).then((res) => {
        if (res.code === 200) {
          try {
            let data =
              typeof res.data === "string" ? JSON.parse(res.data) : res.data;
            let list = data.data || data;
            this.catelist = list;
          } catch (e) {
            this.catelist = [];
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "@/assets/css/base.less";

/* 全局样式 */
.history-container {
  position: relative;
  min-height: 100vh;
  background: linear-gradient( #1A1A1A, #000000) !important;
  color: #fff;
  padding-bottom: 200px; /* 为底部导航留出足够空间 */
}

/* 头部区域 */
.header-section {
  background: linear-gradient(135deg, rgba(0,0,0,0.8), rgba(0,0,0,0.4));
  border-radius: 0 0 2rem 2rem;
  padding: 1rem 1rem 1rem;
  // margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    
    .header-left {
      .logo {
        font-size: 1rem;
        font-weight: bold;
        color: #e7b58e;
        text-shadow: 0 0 10px rgba(231, 181, 142, 0.5);
      }
    }
    
    .header-right {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      
      .kefu-icon,
      .settings-icon {
        color: #e7b58e;
        background-color: rgba(255, 255, 255, 0.1);
        border: 1px solid #6f6f6f;
        border-radius: 50%;
        padding: 0.5rem;
        transition: all 0.3s ease;
        
        &:hover {
          background-color: rgba(231, 181, 142, 0.2);
          transform: scale(1.1);
        }
      }
    }
  }
  
  .hero-section {
    text-align: center;
    
    .hero-title {
      font-size: 2rem;
      font-weight: bold;
      color: #fff;
      margin: 0 0 1rem 0;
      text-shadow: 0 0 15px rgba(255,255,255,0.3);
    }
    
    .hero-subtitle {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1rem;
      flex-wrap: wrap;
      gap: 0.5rem;
      
      .highlight {
        background: linear-gradient(to right, #f7b024, #f99219);
        padding: 0.3rem 1rem;
        color: #000;
        font-weight: bold;
        border-radius: 2rem;
        font-size: 1rem;
        box-shadow: 0 0 10px rgba(247, 176, 36, 0.5);
      }
      
      .subtitle-text {
        font-size: 1.2rem;
        color: #e2e2e2;
      }
    }
    
    .hero-description {
      font-size: 0.9rem;
      color: #ccc;
      font-weight: lighter;
      margin: 0;
      max-width: 80%;
      margin: 0 auto;
    }
  }
}

/* 搜索和状态区域 */
.search-stats-section {
  padding: 0 1rem;
  margin-bottom: 2rem;
  
  .search-container {
    margin-bottom: 1.5rem;
    
    .search-icon {
      width: 1.5rem;
      height: auto;
    }
  }
  
  .stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    
    .stat-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 1rem 1.5rem;
      border-radius: 1.5rem;
      text-align: center;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 5px 15px rgba(0,0,0,0.3);
      }
      
      .stat-icon {
        margin-bottom: 1rem;
        padding: 0.8rem;
        border-radius: 50%;
        background: rgba(255,255,255,0.1);
        
        van-icon {
          color: #e7b58e;
        }
      }
      
      .stat-label {
        color: #feb974;
        font-weight: lighter;
        font-size: 0.9rem;
        margin-bottom: 0.5rem;
      }
      
      .stat-value {
        font-size: 1.8rem;
        font-weight: bold;
        color: #fff;
        margin-bottom: 0.5rem;
      }
      
      .stat-desc {
        color: #ccc;
        font-weight: lighter;
        font-size: 0.8rem;
      }
    }
    
    .featured-card {
      background: linear-gradient(135deg, rgba(189, 138, 73, 0.2), rgba(189, 138, 73, 0.1));
      border: 1px solid rgba(189, 138, 73, 0.3);
    }
    
    .status-card {
      background: linear-gradient(135deg, rgba(9, 215, 226, 0.2), rgba(9, 215, 226, 0.1));
      border: 1px solid rgba(9, 215, 226, 0.3);
    }
  }
}

/* 主内容区域 */
.main-content {
  padding: 0 1rem;
  
  .section-header {
    margin-bottom: 1.5rem;
    
    .channel-label {
      color: #8c835f;
      font-weight: lighter;
      font-size: 0.9rem;
      margin-bottom: 0.5rem;
    }
    
    .content-title {
      color: #fff;
      font-size: 1.5rem;
      font-weight: bold;
    }
  }
  
  /* 内容网格 */
  .content-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-bottom: 2rem;
    
    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    .content-card {
      background: rgba(0,0,0,0.3);
      border-radius: 1.5rem;
      overflow: hidden;
      box-shadow: 0 5px 15px rgba(0,0,0,0.2);
      transition: all 0.3s ease;
      border: 1px solid #444;
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 25px rgba(0,0,0,0.3);
      }
      
      .card-image-container {
        position: relative;
        height: 200px;
        
        .card-image {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .card-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.6));
        }
        
        .card-badges {
          position: absolute;
          top: 1rem;
          left: 1rem;
          right: 1rem;
          display: flex;
          justify-content: space-between;
          
          .private-badge,
          .time-badge {
            font-size: 0.7rem;
            padding: 0.3rem 0.8rem;
            border-radius: 2rem;
            border: 1px solid rgba(255, 255, 255, 0.3);
          }
          
          .private-badge {
            color: #ffc57d;
            background-color: rgba(255, 255, 255, 0.2);
          }
          
          .time-badge {
            color: #fff;
            background-color: rgba(255, 255, 255, 0.2);
          }
        }
      }
      
      .card-body {
        padding: 1.5rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        
        .card-title {
          font-size: 1.3rem;
          font-weight: bold;
          color: #fff;
          margin: 0;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .card-excerpt {
          font-size: 0.9rem;
          color: #ccc;
          line-height: 1.5;
          margin: 0;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .card-tags {
          display: flex;
          gap: 0.5rem;
          flex-wrap: wrap;
          margin: 0;
          
          .tag {
            color: #fff;
            font-weight: lighter;
            font-size: 0.7rem;
            background-color: rgba(255, 255, 255, 0.2);
            padding: 0.3rem 0.8rem;
            border-radius: 2rem;
            border: 1px solid rgba(255, 255, 255, 0.3);
            transition: all 0.3s ease;
            
            &:hover {
              background-color: rgba(231, 181, 142, 0.3);
              border-color: #e7b58e;
            }
          }
        }
        
        .card-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: auto;
          padding-top: 1rem;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          
          .play-btn {
            background: linear-gradient(to right, #f7b024, #f99219);
            color: #000;
            padding: 0.6rem 1.8rem;
            border-radius: 2rem;
            font-size: 0.7rem;
            border: none;
            font-weight: bold;
            box-shadow: 0 0 10px rgba(247, 176, 36, 0.5);
            transition: all 0.3s ease;
            
            &:hover {
              transform: scale(1.05);
              box-shadow: 0 0 15px rgba(247, 176, 36, 0.7);
            }
          }
          
          .receive-text {
            font-size: 0.8rem;
            font-weight: lighter;
            color: #ccc;
            display: flex;
            align-items: center;
            gap: 0.3rem;
            
            &::before {
              content: "";
              display: inline-block;
              width: 0.5rem;
              height: 0.5rem;
              background-color: #e7b58e;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }
  
  /* 无数据提示 */
  .empty-state {
    color: #fff;
    text-align: center;
    padding: 4rem 0;
    font-size: 1.2rem;
    background: rgba(0,0,0,0.2);
    border-radius: 1rem;
    margin: 2rem 0;
  }
  
  /* 分页 */
  .pagination-section {
    margin-top: 2rem;
    padding: 1rem;
    background: rgba(0,0,0,0.2);
    border-radius: 1rem;
  }
}

/* 底部导航 */
::v-deep .van-tabbar {
  margin: 0 auto !important;
  width: 90% !important;
  border-radius: 3rem !important;
  background: rgba(0,0,0,0.8) !important;
  box-shadow: 0 -5px 20px rgba(0,0,0,0.5) !important;
}

/* 搜索框样式 */
::v-deep .van-search {
  margin: 0.5rem 0;
  
  .van-search__content {
    background: rgba(255, 255, 255, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    height: 2.5rem !important;
    display: flex;
    align-items: center;
  }
  
  .van-field__left-icon {
    display: none;
  }
  
  .van-field__control {
    font-size: 0.9rem !important;
    padding-left: 1rem !important;
    font-weight: lighter;
    color: #ccc;
  }
  
  .van-field__right-icon {
    padding-right: 1rem;
  }
}

/* 分页样式 */
::v-deep .van-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  
  .van-pagination__item {
    width: 12vw !important;
    height: 2.8rem !important;
    background: none !important;
    border-radius: 1.5rem !important;
    color: #e7b58e !important;
    border: 1px solid rgba(231, 181, 142, 0.3) !important;
    
    &:active {
      background: rgba(231, 181, 142, 0.2) !important;
    }
  }
  
  .van-pagination__page-desc {
    font-size: 1rem;
    color: #e7b58e;
  }
}

::v-deep .welfare-video-popup {
  width: 92vw;
  max-width: 520px;
  background: transparent;
}

.welfare-video-panel {
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  border: 1px solid rgba(231, 181, 142, 0.55);
  background: #080808;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
}

.welfare-video-close {
  position: absolute;
  z-index: 2;
  top: 0.75rem;
  right: 0.75rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: rgba(0, 0, 0, 0.55);
}

.welfare-video-title {
  min-height: 2.8rem;
  padding: 0.8rem 3.2rem 0.75rem 1rem;
  color: #f6d4a7;
  font-size: 0.95rem;
  line-height: 1.25rem;
  font-weight: 700;
}

.welfare-video-player {
  display: block;
  width: 100%;
  max-height: 72vh;
  background: #000;
}
</style>
